import React, {useEffect, useMemo, useState} from 'react'
import axios from 'axios'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {URL} from '../../gql/client'
import {STORAGE_NAMES} from '../../helpers/consts'
import {useGetUser} from '../../store/userStore'
import {useAiAssistantDrawerStore} from '../../store/aiAssistantDrawerStore'

const containerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 'calc(50% - 10px)',
  right: 0,
  transform: 'translateY(-50%)',
  zIndex: 1051,
}

const buttonStyle: React.CSSProperties = {
  borderRadius: '10px 0 0 10px',
  padding: '8px 12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  position: 'relative',
}

export const AiAssistantFloatingButton: React.FC = () => {
  const open = useAiAssistantDrawerStore((state) => state.open)
  const toggle = useAiAssistantDrawerStore((state) => state.toggle)
  const user = useGetUser((state) => state.user)
  const token = useMemo(
    () => user?.token || window.localStorage.getItem(STORAGE_NAMES.TOKEN) || '',
    [user?.token]
  )
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    if (!token) return
    let cancelled = false
    axios
      .get(`${URL}/api/ai-assistant/config`, {
        headers: {Authorization: `Bearer ${token}`},
      })
      .then((response) => {
        if (!cancelled) setEnabled(Boolean(response.data?.enabled))
      })
      .catch(() => {
        if (!cancelled) setEnabled(false)
      })
    return () => {
      cancelled = true
    }
  }, [token])

  if (!enabled) return null

  const tooltipLabel = open ? 'Hide AI Assistant' : 'Open AI Assistant'

  return (
    <div style={containerStyle} id='global-ai-assistant-floating-button'>
      <OverlayTrigger
        placement='left'
        overlay={<Tooltip id='ai-assistant-floating-tooltip'>{tooltipLabel}</Tooltip>}
      >
        <Button
          style={buttonStyle}
          variant={open ? 'dark' : 'info'}
          title={tooltipLabel}
          onClick={toggle}
        >
          <i className='bi bi-stars fs-4' />
        </Button>
      </OverlayTrigger>
    </div>
  )
}
